import * as React from "react";
import NotificationsMenu from "./NotificationsMenu";
import { Link } from "react-router-dom";
import * as cn from "classnames";
import styles = require("./style.less");
import { session } from "clientInstance";
import PriorityNavigation, { MenuNode } from "components/PriorityNavigation/PriorityNavigation";
import { Permission } from "client/resources";
import { isAllowed } from "components/PermissionCheck/PermissionCheck";
import Environment from "environment";
import UserAccountMenu from "components/Navbar/UserAccountMenu";
import EAPBar from "components/Navbar/EAPBar";
import SvgIconMaterial from "material-ui/SvgIcon";
import ProjectSwitcher from "components/Navbar/ProjectSwitcher";
import routeLinks from "../../routeLinks";
import UpdateAvailableNotificationPoller from "./NotificationPoller/UpdateAvailableNotificationPoller";
import LicenceNotificationPoller from "./NotificationPoller/LicenceNotificationPoller";

const ProjectSwitchIcon = (props: any) => <SvgIconMaterial {...props} color="white" viewBox="0 0 24 24">
    {/* tslint:disable-next-line */}
    <path d="M16.2,6.4c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c1.1,0,2.1-0.3,3-0.9l2.6,2.6c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.4,1-1c0-0.3-0.1-0.5-0.3-0.7l-2.6-2.6c0.6-0.9,0.9-1.9,0.9-3C21.5,8.8,19.1,6.4,16.2,6.4z M16.3,15.3c-1.9,0-3.4-1.6-3.4-3.4c0-1.9,1.6-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4S18.2,15.3,16.3,15.3z M18.9,17.3c-0.8,0.6-1.7,0.7-2.7,0.7c-2.4,0-4.5-1.3-5.5-3.3l-0.1,0H7.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h3c-0.2-0.5-0.3-1-0.3-1.5H7.4C7.2,12.4,7,12.2,7,12s0.2-0.4,0.4-0.4h2.5c0,0,0,0,0,0c0-0.5,0.1-1,0.2-1.5H7.4C7.2,10.1,7,9.9,7,9.7s0.2-0.4,0.4-0.4h3c0.9-2.3,3.2-3.9,5.8-3.9c1.1,0,2.1,0.3,3,0.8V5.7c0-0.9-0.7-1.6-1.6-1.6H1.8c-0.9,0-1.6,0.7-1.6,1.6v12.7c0,0.9,0.7,1.6,1.6,1.6h15.9c0.9,0,1.6-0.7,1.6-1.6V17C19.3,17,19.2,17.2,18.9,17.3z M5.8,13.2h-4v-4h4V13.2z"/>
</SvgIconMaterial>;

interface NavbarState {
    openProjectSwitcher: boolean;
    projectSwitcherAnchorEl: any;
    eapIsHidden: boolean;
}

export default class Navbar extends React.Component<{}, NavbarState> {
    navigationItems: MenuNode[] = [];

    constructor(props: {}) {
        super(props);

        this.state = {
            openProjectSwitcher: false,
            projectSwitcherAnchorEl: null,
            eapIsHidden: false
        };

        this.navigationItems.push({url: routeLinks.root, text: "Dashboard", icon: <i className="fontoctopus-octopus" />, exact: true } as any);
        if (isAllowed({permission: Permission.ProjectView, wildcard: true})) {
            this.navigationItems.push({url: routeLinks.projects, text: "Projects"} as any);
        }
        if (isAllowed({permission: Permission.ProjectView, wildcard: true})) {
            this.navigationItems.push({url: null, icon: <ProjectSwitchIcon />, onClick: this.toggleProjectSwitcher });
        }
        if (isAllowed({permission: Permission.MachineView, wildcard: true})) {
            this.navigationItems.push({url: routeLinks.infrastructure.root, text: "Infrastructure"} as any);
        }
        if (session.currentFeatures.IsMultiTenancyEnabled && isAllowed({permission: Permission.TenantView, tenant: "*"})) {
            this.navigationItems.push({url: routeLinks.tenants, text: "Tenants"} as any);
        }
        if (isAllowed({
            permission: [Permission.FeedView, Permission.LifecycleEdit, Permission.VariableView, Permission.ActionTemplateView, Permission.CertificateView],
            wildcard: true
        })) {
            this.navigationItems.push({url: routeLinks.library.root, text: "Library"} as any);
        }
        if (isAllowed({permission: Permission.TaskView, wildcard: true})) {
            this.navigationItems.push({url: routeLinks.tasks.root, text: "Tasks"} as any);
        }
        if (isAllowed({permission: [Permission.AdministerSystem, Permission.AuditView, Permission.TeamView, Permission.UserView, Permission.UserRoleView]})) {
            this.navigationItems.push({url: "/configuration", text: "Configuration"} as any);
        }

        if (Environment.isInDevelopmentMode() && !this.state.eapIsHidden) {
            this.navigationItems.push({url: "/style-guide", text: "Style Guide [dev]"} as any);
            this.navigationItems.push({url: "/code-guide", icon: <i className="fa fa-industry" />, text: "Code Guide [dev]" } as any);
        }
    }

    onEAPClosed() {
        if (Environment.isInDevelopmentMode() && !this.state.eapIsHidden) {
            this.navigationItems.pop();
            this.navigationItems.pop();
        }
        this.setState({eapIsHidden: true});
    }

    render() {
        // The topnavbar id is used by E2E UI tests
        return <div id="topnavbar" className={styles.topnavbar}>
            <EAPBar
                onCloseClicked={() => this.onEAPClosed()}/>
            <div className={styles.navbar}>
                <PriorityNavigation navigationItems={this.navigationItems} maxNavigationItems={99}
                    activeItemClassName={styles.navItemActive} className={styles.navbarCenter} showHamburgerIcon={true} />
                {isAllowed({permission: Permission.ProjectView, wildcard: true}) &&
                <ProjectSwitcher open={this.state.openProjectSwitcher} onRequestClose={this.closeProjectSwitcher} anchorEl={this.state.projectSwitcherAnchorEl} />}
                <div className={styles.navbarRight}>
                    <UpdateAvailableNotificationPoller />
                    <LicenceNotificationPoller />
                    <NotificationsMenu />
                    <UserAccountMenu currentUser={session.currentUser} />
                </div>
            </div>
        </div>;
    }

    private closeProjectSwitcher = () => {
        this.setState({
            openProjectSwitcher: false
        });
    }

    private toggleProjectSwitcher = (e: any) => {
        this.setState({
            openProjectSwitcher: !this.state.openProjectSwitcher,
            projectSwitcherAnchorEl: e
        });
    }

    private iconLink(route: string, icon: string, additionalClassName?: string) {
        return <Link className={cn(styles.navbarButton, additionalClassName)} to={route}>
            <i className={cn(icon, styles.navbarIcon)} />
        </Link>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navbar/Navbar.tsx